import { useState } from "react";
import AdminTopbar from "../../components/topbars/AdminTopbar";
import { generarTurnos } from "../../api/apiResources";
import "./Dashboard.css";

const Dashboard = () => {
    const cards = [
        { label: "Turnos activos", value: "128", change: "+12%" },
        { label: "Médicos", value: "34", change: "+4" },
        { label: "Pacientes", value: "842", change: "+31" },
        { label: "Servicios", value: "18", change: "+2" },
    ];

    const [generando, setGenerando] = useState(false);
    const [resultado, setResultado] = useState(null); // { ok, cantidad, error }

    const handleGenerarTurnos = async () => {
        setGenerando(true);
        setResultado(null);
        try {
            const data = await generarTurnos();
            setResultado({ ok: true, cantidad: data.cantidad ?? 0 });
        } catch (e) {
            setResultado({ ok: false, error: e.message || "Error al generar turnos." });
        } finally {
            setGenerando(false);
        }
    };

    return (
        <>
            <AdminTopbar
                title="Dashboard"
                subtitle="Resumen general del funcionamiento de la clínica."
                actionLabel={generando ? "Generando..." : " Generar turnos"}
                onAction={generando ? undefined : handleGenerarTurnos}
            />

            {resultado && (
                <div className={`dashboard-resultado ${resultado.ok ? "dashboard-resultado--ok" : "dashboard-resultado--error"}`}>
                    {resultado.ok
                        ? `✓ Generación completada: ${resultado.cantidad} turno${resultado.cantidad !== 1 ? "s" : ""} nuevo${resultado.cantidad !== 1 ? "s" : ""} creado${resultado.cantidad !== 1 ? "s" : ""}.`
                        : `✗ ${resultado.error}`}
                </div>
            )}

            <section className="dashboard-grid">
                {cards.map((card) => (
                    <article className="dashboard-card" key={card.label}>
                        <span>{card.label}</span>
                        <strong>{card.value}</strong>
                        <small>{card.change} este mes</small>
                    </article>
                ))}
            </section>
        </>
    );
};

export default Dashboard;